<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">Cake Order Products</a>
      </label>
    </div>

    <hr class="gold-hr">

    <section class="main-content wrapper scroll-delivery">
      <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>

      <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
        <form class="table-row-container row first-row filter" [formGroup]="cakeOrdersFilterForm" *ngIf="cakeOrdersFilterForm" (ngSubmit)="filter()">
            <div class="item data-col-10 hideOnPhoneView">
                <h4 class="title" (click)="navigateOrder('CakeOrderInfo.id')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('CakeOrderInfo.id')"></i>
                  ID
                </h4>
                <span class="data">
                  <input type="number" min="1000" max="10000" formController="CakeOrderInfo.id">
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title">FOTO</h4>
                <span class="data"></span>
            </div>
      
            <!--
            <div class="item data-col-20 hideOnPhoneView">
                <h4 class="title" (click)="navigateOrder('CakeOrderInfo.name')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('CakeOrderInfo.name')"></i>
                  NOME
                </h4>
                <span class="data">
                  <input type="text" formControlName="CakeOrderInfo.name" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
                </span>
            </div>

            <div class="item data-col-20 hideOnPhoneView">
              <h4 class="title" (click)="navigateOrder('CakeOrderInfo.sku')">
                <i class="sort-icon fas" [ngClass]="orderIcon('CakeOrderInfo.sku')"></i>
                SKU
              </h4>
              <span class="data">
                <input type="text" formControlName="CakeOrderInfo.sku" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
              </span>
            </div>

            <div class="item data-col-20 hideOnPhoneView">
              <h4 class="title" (click)="navigateOrder('CakeOrderInfo.description')">
                <i class="sort-icon fas" [ngClass]="orderIcon('CakeOrderInfo.description')"></i>
                DESCRIPTION
              </h4>
              <span class="data">
                <input type="text" formControlName="CakeOrderInfo.description" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
              </span>
            </div>

            <div class="item data-col-20 hideOnPhoneView">
              <h4 class="title" (click)="navigateOrder('CakeOrderInfo.price')">
                <i class="sort-icon fas" [ngClass]="orderIcon('CakeOrderInfo.price')"></i>
                PRICE
              </h4>
              <span class="data">
                <input type="text" formControlName="CakeOrderInfo.price" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
              </span>
            </div>

            <div class="item data-col-5 hideOnPhoneView">
                <h4 class="title">Azioni</h4>
                <span class="data saifu">
                  <button class="btn hvr-grow" (click)="$event.preventDefault(); filter()">
                    <i class="fas fa-search"></i>
                  </button>
                  <button class="btn hvr-grow" (click)="$event.preventDefault(); resetFilter()">
                    <i class="fas fa-undo"></i>
                  </button>
                </span>
            </div>
            <hr class="hr-clear">
            -->
        </form>

        <div class="table-row-container row" *ngFor="let cakeOrderProduct of cakeOrderProducts">

            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  ID
                </h4>
                <div class="data data-id">
                  <div>{{ cakeOrderProduct?.id || "---" }}</div>
                </div>
            </div>

            <div class="item data-col-10">
                <h4 class="title">Foto</h4>
                <span class="data" style="cursor: pointer"><img *ngIf="cakeOrderProduct?.imageUrl" [src]="cakeOrderProduct?.imageUrl" class="product-image" (click)="openImage(cakeOrderProduct?.imageUrl? cakeOrderProduct?.imageUrl : '')"></span>
            </div>

            <!--
            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Nome
                </h4>
                <div class="data">
                  <div>
                    <span>
                    {{ cakeOrderProduct?.name || "---" }}
                    </span>
                  </div>
                </div>
            </div>
        
            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  SKU
                </h4>
                <div class="data">
                  <div>{{ cakeOrderProduct?.sku || "---" }}</div>
                </div>
            </div>

            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  DESCRIPTION
                </h4>
                <div class="data">
                  <div>{{ cakeOrderProduct?.description || "---" }}</div>
                </div>
            </div>

            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  PRICE
                </h4>
                <div class="data">
                  <div>€{{ cakeOrderProduct?.price || "---" }}</div>
                </div>
            </div>

            <div class="item data-col-5">
                <h4 class="title"></h4>
                <span class="data saifu">
                  <button class="btn hvr-grow has-margin-right has-margin-bottom has-margin-right has-margin-top">MODIFICA</button>
                  &nbsp;
                  <a (click)="$event.preventDefault();">
                    <span class="btn btn-red hvr-grow">Elimina<i class="ml-10 far fa-trash-alt"></i></span>
                  </a>
                </span>
            </div>
            -->
        </div>
      </div>
    </section>
  </div>
</section>

<!--
<section class="title-bar content-padding first-item">
  <div class="wrapper">
    <h2 class="left">Cake Order Products</h2>
    <br class="clear">
  </div>
</section>

<section class="main-content wrapper content-padding">
  <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage"></app-pagination>
  <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
      <form class="table-row-container row first-row filter" [formGroup]="cakeOrdersFilterForm" *ngIf="cakeOrdersFilterForm" (ngSubmit)="filter()">
          <div class="item data-col-10 hideOnPhoneView">
              <h4 class="title" (click)="navigateOrder('CakeOrderInfo.id')">
                <i class="sort-icon fas" [ngClass]="orderIcon('CakeOrderInfo.id')"></i>
                ID
              </h4>
              <span class="data">
                <input type="number" min="1000" max="10000" formController="CakeOrderInfo.id">
              </span>
          </div>

          <div class="item data-col-10">
              <h4 class="title">FOTO</h4>
              <span class="data"></span>
          </div>
      </form>

      <div class="table-row-container row" *ngFor="let cakeOrderProduct of cakeOrderProducts">

          <div class="item data-col-10">
              <h4 class="title">
                <i class="sort-icon fas"></i>
                ID
              </h4>
              <div class="data data-id">
                <div>{{ cakeOrderProduct?.id || "---" }}</div>
              </div>
          </div>

          <div class="item data-col-10">
              <h4 class="title">Foto</h4>
              <span class="data" style="cursor: pointer"><img *ngIf="cakeOrderProduct?.imageUrl" [src]="cakeOrderProduct?.imageUrl" class="product-image" (click)="openImage(cakeOrderProduct?.imageUrl? cakeOrderProduct?.imageUrl : '')"></span>
          </div>

      </div>
  </div>
</section>
-->